import React, {useCallback, useMemo} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  MODE_CREATE,
  MODE_EDIT,
  RULE_TYPE_CONTAINS,
  RULE_TYPE_ENDS_WITH,
  RULE_TYPE_EQUALS,
  RULE_TYPE_STARTS_WITH
} from "../../../../codes";
import Editor from "../../../../common/Editor";
import useRuleEditor from "./useRuleEditor";
import {AppStaticDropdown} from "../../../../common/AppStaticDropdown";
import {CategoriesDropdown} from "../../../../common/CategoriesDropdown";
import {DeleteModal} from "../../../../common/AppModal";
import useProject from "../../../../util/useProject";

export const RuleEditor = () => {
  const {
    show,
    t,
    mode,
    hideRuleEditor,
    editedRule,
    updateEditedRule,
    submit,
    availableCategories,
    deleteConfirmationModal,
    showDeleteConfirmationModal,
    hideDeleteConfirmationModal,
    onDeleteRule
  } = useRuleEditor();

  const {runWithExpiration} = useProject();

  const types = useMemo(() => {
    return [
      {value: RULE_TYPE_CONTAINS, label: t("rule_type_contains")},
      {value: RULE_TYPE_EQUALS, label: t("rule_type_equals")},
      {value: RULE_TYPE_STARTS_WITH, label: t("rule_type_starts_with")},
      {value: RULE_TYPE_ENDS_WITH, label: t("rule_type_ends_with")}
    ];
  }, [t]);

  return <Editor
    show={show}
    title={t(mode === MODE_CREATE ? "rule_editor_title_add" : "rule_editor_title_edit")}
    onShow={useCallback(() => document.getElementById("rule-editor-type").focus(), [])}
    onSubmit={runWithExpiration(submit)}
    onCancel={hideRuleEditor}
    onDelete={mode === MODE_EDIT ? runWithExpiration(showDeleteConfirmationModal) : null}
    submitLabel={t("rule_editor_button_save")}
    cancelLabel={t("rule_editor_button_cancel")}
  >
    <Form.Group as={Row} className="mb-2">
      <Form.Label column sm={4}>{t("rule_editor_field_type")}</Form.Label>
      <Col sm={4}>
        <AppStaticDropdown
          id="rule-editor-type"
          value={editedRule.type}
          choices={types}
          onChange={updateEditedRule("type")}
        />
      </Col>
      <Col sm={4}>
        <Form.Control type="text" id="rule-editor-value" value={editedRule.value}
                      placeholder={t("rule_editor_field_value_placeholer")} onChange={updateEditedRule("value")}
                      isInvalid={editedRule.errors.value}/>
        <Form.Control.Feedback type="invalid">{t(editedRule.errors.value)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="rule-editor-payee">
      <Form.Label column sm={4}>{t("rule_editor_field_payee")}</Form.Label>
      <Col sm={8}>
        <Form.Control
          type="text"
          value={editedRule.payee}
          onChange={updateEditedRule("payee")}
          maxLength="100"
          isInvalid={editedRule.errors.payee}
        />

        <Form.Control.Feedback type="invalid">{t(editedRule.errors.payee)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="rule-editor-category">
      <Form.Label column sm={4}>{t("rule_editor_field_category")}</Form.Label>
      <Col sm={8}>
        <CategoriesDropdown
          categories={availableCategories}
          value={editedRule.category}
          onChange={updateEditedRule("category")}
        />

        <Form.Control.Feedback type="invalid">{t(editedRule.errors.payee)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="rule-editor-tags">
      <Form.Label column sm={""}>{t("rule_editor_field_tags")}</Form.Label>
      <Col sm={8}>
        <Form.Control type="text" value={editedRule.tags || ""} onChange={updateEditedRule("tags")}/>
      </Col>
    </Form.Group>

    <DeleteModal
      show={deleteConfirmationModal}
      title={t("modal_delete_title")}
      cancelLabel={t("modal_delete_button_cancel")}
      submitLabel={t("modal_delete_button_apply")}
      onCancel={hideDeleteConfirmationModal}
      onSubmit={onDeleteRule}
    >
      {t("modal_delete_body")}
    </DeleteModal>
  </Editor>;
};
